module.exports = __webpack_public_path__ + "static/img/91BM-059-QiangjiangWang.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-059-QiangjiangWang.jpg
// module id = FW6W
// module chunks = 0